export default __webpack_public_path__ + "static/media/Picture1.c2fd8b0f.png";